import { FrequencyLabel } from 'ui/components/Labels'
import { Link } from 'ui/components/Link'
import { TableColumn } from 'ui/components/Table'
import { SiteAuditDocumentsReportItem } from '~bank-reports/types/SiteAuditDocumentsReport'

import { LastNote } from './LastNotes/LastNotes'

export const columns = (availableSortFields: string[]): TableColumn<SiteAuditDocumentsReportItem>[] => [
  {
    title: 'Relationship',
    align: 'left',
    sortable: availableSortFields?.includes('relationshipName'),
    key: 'relationshipName',
    render: (item: SiteAuditDocumentsReportItem) => (
      <Link to={`/relationships/$id`} params={{ id: item.relationshipId.toString() }}>
        {item.relationshipName}
      </Link>
    )
  },
  {
    title: 'License Number',
    key: 'licenseNumber',
    align: 'left',
    sortable: availableSortFields?.includes('licenseNumber')
  },
  {
    title: 'Street',
    key: 'street',
    align: 'left'
  },
  {
    title: 'City',
    key: 'city',
    align: 'left'
  },
  {
    title: 'State',
    key: 'state',
    align: 'left'
  },
  {
    title: 'Postal Code',
    key: 'postalCode',
    align: 'left'
  },
  {
    title: 'Next Due Date',
    key: 'nextDueDate',
    align: 'left',
    sortable: availableSortFields?.includes('nextDueDate')
  },
  {
    title: 'Last Period Approved',
    key: 'lastPeriodApproved',
    align: 'left',
    sortable: availableSortFields?.includes('lastPeriodApproved')
  },
  {
    title: 'Frequency',
    align: 'left',
    key: 'frequency',
    render: ({ frequency }) => <FrequencyLabel name={frequency} />
  },
  {
    title: 'Last Notes',
    align: 'left',
    key: 'lastNotes',
    render: (item: SiteAuditDocumentsReportItem) => <LastNote note={item.lastNotes} id={item.documentId} />
  }
]
